import { render, staticRenderFns } from "./taskInfoList.vue?vue&type=template&id=b40ab188&"
import script from "./taskInfoList.vue?vue&type=script&lang=js&"
export * from "./taskInfoList.vue?vue&type=script&lang=js&"
import style0 from "./taskInfoList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports